function Layer({config = {}, beforeLayerId = []}) {
  this.config = config;
  this.beforeLayerId = beforeLayerId;
}

export default Layer;
